import React from 'react';
import { useTranslation } from 'react-i18next';
import { CheckboxList } from '../../../shared';
import { getCheckboxItems } from '../getCheckboxItems';
export var JobTypeFilter = function (_a) {
    var jobTypeFilterState = _a.jobTypeFilterState, jobTypeFilterOptions = _a.jobTypeFilterOptions, onFilterStateChange = _a.onFilterStateChange;
    var t = useTranslation().t;
    var title = React.useMemo(function () {
        return t('shift_management_views_filters_jobType_title');
    }, []);
    var checkboxListItems = getCheckboxItems(jobTypeFilterOptions, {
        alphabetize: true
    });
    return (React.createElement(CheckboxList, { title: title, dataTestId: "job-type-filters", checkboxState: jobTypeFilterState, onStateChange: onFilterStateChange, checkboxListItems: checkboxListItems }));
};
